import UiStore from "./UiStore";
import MapStore from "./MapStore";
import CommunicationStore from "./CommunicationStore";
import LayerStore from "@giscon/utils.layer-store";
import { makeObservable, observable } from "mobx";

class RootStore {
  config = {};

  constructor() {
    this.LayerStore = LayerStore;
    this.mapStore = new MapStore(this);
    this.uiStore = new UiStore(this);
    this.communicationStore = new CommunicationStore(this);
    this.history = [];
    makeObservable(this, { history: observable.ref });
  }
}

export default new RootStore();
